import React from 'react';
import HeroSection from '../components/home/HeroSection';
import StatsSection from '../components/home/StatsSection';
import CareerPrograms from '../components/home/CareerPrograms';
import TrainingSystem from '../components/home/TrainingSystem';
import CareerSupport from '../components/home/CareerSupport';
// import MentorSection from '../components/home/MentorSection';
import StudentResults from '../components/home/StudentResults';
import WhyChooseUs from '../components/home/WhyChooseUs';
import FinalCTA from '../components/home/FinalCTA';
export default function Home() {
  return (
    <>
      <HeroSection />
      <StatsSection />
      <CareerPrograms />
      <TrainingSystem />
      {/* <MentorSection /> */}
      <CareerSupport />
      <StudentResults />
      <WhyChooseUs />
      <FinalCTA />
    </>
  );
}